(function(angular){
	'use strict';

	angular
		.module('investorUpdatesModule')
		.controller('InvestorUpdate', [
			'APP_BASE_PATH',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'localStorageFactory',
			'PropertyService',
			'ReitElementFactory',
			'urlFactory',
			InvestorUpdateFunction
		]);

	function InvestorUpdateFunction(
		APP_BASE_PATH,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		localStorageFactory,
		PropertyService,
		ReitElementFactory,
		urlFactory
	){
		var investorUpdate = this;

		angular.extend(investorUpdate, globalConfig);
		investorUpdate.investmentEntityId = INVESTMENT_ENTITY_ID;
		investorUpdate.existingUser = localStorageFactory.getItem('existingUser');
		investorUpdate.basePath = APP_BASE_PATH;

		ReitElementFactory.getReitElementListsForDashboard()
			.then(function(reitElementLists) {
				angular.extend(investorUpdate, reitElementLists);
			});

		if(angular.isDefined(investorUpdate.investmentEntityId)) {
			var updatesUrl = '/api-secured/investment-entity/' + investorUpdate.investmentEntityId + '/updates';
			urlFactory.apiGetPromise(updatesUrl).then(function(response) {
				investorUpdate.updates = response.data;
			},
			function(response) {
				urlFactory.handleFailedRequest(response);
			});
		}

	}
})(window.angular);